module.exports = __webpack_public_path__ + "static/img/logo_color.56a0254.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_color.svg
// module id = MsRX
// module chunks = 1